<style lang="less">
    @import "./vip.less";
</style>
<template>
<!--    添加高度是因为会出现距离footer增大 height: 1228px;-->

    <div class="vipparent" style="height:900px;">
        <div class="vip_background">
            <div class="vip_back_img_content" style="padding-top:32px">
                <div class="img_con">
                    <img src="../../../assets/vip_background.png" alt='版权登记'/>
                    <div class="img_con_fi" style="top:0px">
                        <p></p>
                        <p class="img_vip">VIP</p>
                        <p></p>
                    </div>
                    <div class="img_con_se" style="top:29px">
                        <p>七天试用会员</p>
                    </div>
                    <div class="img_con_th" style="top:100px">
                        COPYRIGHT PROTECTION
                    </div>
                    <input @click="goMemberTy()" class="img_con_msty" type="button" value="马上体验" />
                </div>
            </div>
        </div>
        <div class="vip_content" style="top:-114px;width:989px;border-radius:10px;">
            <div class="vip_cont_content">
                <div class="vip_cont_table" style="width:989px;border:none;"> <!--height:850px;-->
                    <Row class-name="rowtitle" style="height:75px;line-height:75px;background:linear-gradient(270deg,rgba(236,208,132,1) 0%,rgba(233,191,113,1) 100%)">
<!--                        <Col class-name="coltitle" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">
                            <div style="visibility:hidden">占位</div>
                        </Col>-->
                        <Col class-name="coltime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">会员权益</Col>
                        <Col class-name="coltime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">权益次数</Col>
                    </Row>
                    <Row class-name="rowcolor" style="border:none;background:#fff">
                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">
                            <div style="margin-left:198px">1</div>
                            <p>版权存证</p>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.evidenceArchiveNum}}次</Col>
                    </Row>
<!--                    <Row class-name="rowcolor" style="background:rgba(252,252,252,1)">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                            <div style="margin-left:82px">2</div>-->
<!--                            <p>版权登记</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">免费</Col>-->
<!--                        &lt;!&ndash; <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.certificateRegistrationNum}}次</Col> &ndash;&gt;-->
<!--                    </Row>-->
<!--                    <Row class-name="rowcolor" style="border:none;background:rgba(252,252,252,1)">
                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">
                            <div style="margin-left:198px">2</div>
                            <p>图片监测</p>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.imageMonitorNum}}次</Col>
                    </Row>
                    <Row class-name="rowcolor" style="background:#fff">
                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">
                            <div style="margin-left:198px">3</div>
                            <p>音乐监测</p>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.musicMonitorNum}}次</Col>
                    </Row>
                    <Row class-name="rowcolor" style="border:none;background:rgba(252,252,252,1)">
                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">
                            <div style="margin-left:198px">4</div>
                            <p>文字监测</p>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.textMonitorNum}}次</Col>
                    </Row>-->
<!--                    <Row class-name="rowcolor" style="background:rgba(252,252,252,1);border-bottom:none">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                            <div style="margin-left:82px">5</div>-->
<!--                            <p>电子公证</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.notarizationNum}}次</Col>-->
<!--                    </Row>-->
                    <Row class-name="rowcolor" style="background:#fff">
                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">
                            <div style="margin-left:198px">2</div>
                            <p>版权取证</p>
                        </Col>
                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.forensicsNum}}次</Col>
                    </Row>
<!--                    <Row class-name="rowcolor" style="border:none;background:rgba(252,252,252,1)">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                            <div style="margin-left:82px">7</div>-->
<!--                            <p>电话问律师30分钟</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.lawyerConsult30Num}}次</Col>-->
<!--                    </Row>-->
<!--                    <Row class-name="rowcolor" style="border:none;background:#fff">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                        <div style="margin-left:82px">8</div>-->
<!--                        <p>电话问律师60分钟</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.lawyerConsult60Num}}次</Col>-->
<!--                    </Row>-->
<!--                    <Row class-name="rowcolor" style="border:none;background:rgba(252,252,252,1)">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                        <div style="margin-left:82px">9</div>-->
<!--                        <p>出具律师函</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.lawyerLetterNum}}次</Col>-->
<!--                    </Row>-->
<!--                    <Row class-name="rowcolor" style="border:none;background:#fff">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                        <div style="margin-left:82px">10</div>-->
<!--                        <p>侵权下架</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.tortShelvesNum}}次</Col>-->
<!--                    </Row>-->
<!--                    <Row class-name="rowcolor" style="border:none;background:rgba(252,252,252,1)">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                        <div style="margin-left:82px">11</div>-->
<!--                        <p>合同审核</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.contractAuditNum}}次</Col>-->
<!--                    </Row>-->
<!--                    <Row class-name="rowcolor" style="border:none;background:#fff">-->
<!--                        <Col :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))" class-name="colcommonContent" style="margin-left:0px;">-->
<!--                        <div style="margin-left:82px">12</div>-->
<!--                        <p>侵权判定+维权方案设计</p>-->
<!--                        </Col>-->
<!--                        <Col class-name="colsubtime" v-for="(item,index) in vipList" :key="index" :span="Math.floor(24/(vipList.length+1))==0?1:Math.floor(24/(vipList.length+1))">{{item.registerVipRights.infringementDeterminationNum}}次</Col>-->
<!--                    </Row>-->
                </div>
                <div class="goPersonVip">
                    <div class="goPersonVip_left">
                        <input @click="goVip()" type="button" :value="showText+'VIP'" />
                        <div class="goPersonVip_right">
                            <img src="../../../assets/tooltip_z.png" alt='版权登记'/>
                            <p>12个月</p>
                        </div>
                    </div>
                    <input @click="goMemberTy()" style="margin-left:160px;margin-right:157px" type="button" value="马上体验" />
                </div>
            </div>
        </div>
        <!-- <lawCommon /> -->
        <myPay :subBizType="subBizTypesb" :payMoney="payMoney" @updatePayTxt="updatePayTxt"  @fatherModal="fatherModal" mywidth='766' myHeight="425" myTitleheight="50" v-if="showModal" />
        <mycapay @fatherModal="fatherModal" mywidth='838' myheight="585" myTitleheight="50" v-if="showModal02" />
    </div>
</template>

<script>
    import {getSevenVip,postMemberApplication,goPersonOrEnterVip} from '@/api/staticPage'
    import lawCommon from './lawcomponent/lawcomponentbl.vue'
    import myPay from './lawcomponent/mypay.vue'
    import Cookies from "js-cookie";
    import mycapay from './lawcomponent/myczpay.vue';
    import { userInfo} from "@/api/index";
    export default {
        metaInfo: {
            title: '七天试用会员|版权服务专家|版权家',
            meta: [{                 // set meta
                name: 'keyWords',
                content: '版权服务,版权百科,版权,版权家,版权存证,版权交易,版权监测,版权维权,版权登记,版权公证,版权签名,数字版权,版全家,版权侵权取证,版权法律维权服务,区块链版权登记,区块链版权确权,区块链版权存证,区块链版权'
            },{
                name: 'Description',
                content: '七天试用会员,版权家,人人都是创作者，人人都是版权人。版权家秉持让版权实现更大价值的使命，使用创新的版权区块链和版权签名技术，为版权人提供极致的版权存证、版权交易、版权监测、版权维权服务体验。'
            }]
        },
        name:'vipseven',
        components:{
           lawCommon,
           myPay,
           mycapay
        },
        data(){
            return {
                vipList:[],
                subBizType:'',
                showModal:!1,
                showModal02:!1,
                payList:[],
                subBizTypesb:'',
                payMoney:0,
                showText:'开通'
            }
        },
        created(){
            let userInfosd = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
//            this.showText = userInfosd==''?'开通':userInfosd && (userInfosd.accountType=='enterprise'||userInfosd.vipFlag=='0' || userInfosd.vipFlag=='2')?'开通':'续费'
            this.showText = userInfosd==''?'开通': userInfosd.vipFlag=='0' || userInfosd.vipFlag=='2'?'开通':'续费'
        },
        methods:{
            _goPersonOrEnterVip(){
                goPersonOrEnterVip({accountScope:'person'}).then(res => {
                    if(res.code == 200){
                        this.payList = []
                        let middleGv = res.result
                        for(let i = 0; i < middleGv.length; i++){
                            if(middleGv[i].accountScope=='person'){
                                this.payList.push(middleGv[i])
                            }
                        }
                    }
                })
            },
            _getSevenVip(){
                getSevenVip().then(res => {
                    console.log('------------------------',res)
                    this.vipList = []
                    if(res.code == 200){
                        let vipList = res.result
                        this.vipList.push(vipList)
                        this.subBizType = res.result.code
                    }
                })
            },
            goMemberTy(){
               let _this = this;
//                _this.getUserStaus();
//                 let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
//                 if(userInfo==''){
//                     toast('请登录后再体验VIP会员',function(){
//                         this.$router.push({
//                             path: '/'
//                         })
//                     })
//                     return false;
//                 }
//                 if(userInfo.realNameStatus != 'complete_real_name'){
//                     toast('请实名认证后再操作',function(){
//                         _this.$router.push({
//                             path:'/authentication'
//                         })
//                     })
//                     return false;
//                 }
//                 let params = {
//                     registerId:userInfo && userInfo.id?userInfo.id:'',
//                     subBizType:this.subBizType,
//                     payWay:'free'
//                 }
//                 postMemberApplication(params).then(res=>{
//                     console.log('获取免费体验的资格',res)
//                     if(res.code == 200){
//                         toast('免费体验会员已申请成功，请开始体验')
//                     }
//                 })

                /**
                 * 这里原来用_this.getUserStaus，但是，实名认证通过后，第一次获取状态的时候，userInfo()的请求截取不到，第二次就可以了，
                 * 死活找不到原因，ansyc await 也测试了，只能把判断写在获取用户信息里面
                 */
                console.log("测试 111 ：start ");
                userInfo().then(res=>{
                    console.log("测试 111 ：获取用户状态返回值 ：：：：",res);
                    // debugger

                    if(res.code=="200"){
                        let uInfo = res.result;
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        _this.setStore("userInfo", uInfo );
                        console.log("\"测试 111 ： 返回值 ：：：",uInfo)
                        if(uInfo==''){
                            toast('请登录后再体验VIP会员',function(){
                                _this.$router.push({
                                    path: '/'
                                })
                            })
                            return false;
                        }
                        if(uInfo.realNameStatus != 'complete_real_name'){
                            toast('请实名认证后再操作',function(){
                                _this.$router.push({
                                    path:'/authentication'
                                })
                            })
                            return false;
                        }
                        let params = {
                            registerId:uInfo && uInfo.id?uInfo.id:'',
                            subBizType:_this.subBizType,
                            payWay:'free'
                        }
                        postMemberApplication(params).then(res=>{
                            console.log('获取免费体验的资格',res)
                            if(res.code == 200){
                                toast('免费体验会员已申请成功，请开始体验')
                            }
                        })
                    }else{
                        toast(res.message);
                    }
                });

            },
            fatherModal() {
                let _this = this;
                _this.showModal = !1;
                _this.showModal02=!1;
            },
            goVip(){
                let _this = this;
                _this.$router.push({
                    path:'/huiyuan.html'
                });
//                let _this = this;
//                let userInfo = Cookies.get("userInfo")?JSON.parse(Cookies.get("userInfo")):'';
//                console.log(userInfo)
//                if(userInfo==''){
//                    toast('请登录后再操作',function(){
//                        _this.$router.push({
//                            path:'/'
//                        })
//                    })
//                    return false;
//                }
//                if(userInfo.realNameStatus != 'complete_real_name'){
//                    toast('请实名认证后再操作',function(){
//                        _this.$router.push({
//                            path:'/authentication'
//                        })
//                    })
//                    return false;
//                }
//                if(userInfo.accountType=='enterprise'){
//                    toast('企业VIP、个人VIP无法互转')
//                    return false;
//                }
//                if(userInfo.vipFlag=='0' || userInfo.vipFlag=='2'){
//                    this.showModal = !0;
//                }else{
//                    this.showModal02 = !0;
//                }
//                // this.showModal = !0;
//                let array = this.payList
//                for(let i=0;i<array.length;i++){
//                    if(array[i].periodType=='month' && array[i].period=='12' || array[i].periodType=='year' && array[i].period=='1'){
//                        this.subBizTypesb = array[i].code
//                        this.payMoney = array[i].value
//                    }
//                }
            },
            //更改按钮文案
            updatePayTxt(){
                this.showText='续费'
            },
            getUserStaus(){
                userInfo().then(res=>{
                    if (res.code==200) {
                        Cookies.set("userInfo", JSON.stringify(res.result));
                        this.setStore("userInfo", res.result);
                    }
                })
            }
        },
        mounted(){

            this._getSevenVip();
            this._goPersonOrEnterVip();
        }
    }
</script>
